export type SpeechBubbleStyle = 'default' | 'cloud' | 'neon' | 'pixel';

export interface SpeechStyleOption {
  id: SpeechBubbleStyle;
  labelKey: string;
}

export const DEFAULT_SPEECH_STYLE: SpeechBubbleStyle = 'default';

export const SPEECH_STYLE_OPTIONS: SpeechStyleOption[] = [
  { id: 'default', labelKey: 'speech.styles.default' },
  { id: 'cloud',   labelKey: 'speech.styles.cloud' },
  { id: 'neon',    labelKey: 'speech.styles.neon' },
  { id: 'pixel',   labelKey: 'speech.styles.pixel' },
];

export const isPremiumSpeechStyle = (style: SpeechBubbleStyle): boolean =>
  style !== DEFAULT_SPEECH_STYLE;
